// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { AddressResponse } from './address-response';

// @ts-ignore
import { ContactResponse } from './contact-response';

// @ts-ignore
import { EmergencyContactStatusResponse } from './emergency-contact-status-response';

// @ts-ignore
import { PhoneNumbersResponse } from './phone-numbers-response';

/** See com.rev360.pms.api.controller.patient.contact.ContactWithEmergencyContactResponse */
/* istanbul ignore next */
@GandalfModel
export class ContactWithEmergencyContactResponse extends ContactResponse {

	@GandalfProperty({ designType: AddressResponse })
	address!: AddressResponse | null;

	@GandalfProperty({ designType: String })
	credentials!: string | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	dob!: Date | null;

	@GandalfProperty({ designType: String })
	email!: string | null;

	@GandalfProperty({ designType: EmergencyContactStatusResponse })
	emergencyContactStatusResponse!: EmergencyContactStatusResponse | null;

	@GandalfProperty({ designType: String })
	firstName!: string | null;

	@GandalfConstantDecorator(constants.Gender)
	@GandalfProperty({ designType: constants.Gender })
	gender!: constants.Gender | null;

	@GandalfProperty({ designType: Number })
	id!: number | null;

	@GandalfProperty({ designType: String })
	lastName!: string | null;

	@GandalfProperty({ designType: String })
	middleName!: string | null;

	@GandalfProperty({ designType: String })
	nickname!: string | null;

	@GandalfProperty({ designType: Number })
	personId!: number | null;

	@GandalfProperty({ designType: PhoneNumbersResponse })
	phones!: PhoneNumbersResponse | null;

	@GandalfProperty({ designType: Number })
	roleId!: number | null;

	@GandalfProperty({ designType: String })
	ssn!: string | null;

	@GandalfProperty({ designType: String })
	suffix!: string | null;

	@GandalfProperty({ designType: Number })
	titleId!: number | null;

}
